module.exports = __webpack_public_path__ + "img/board-1.4be5bf2e.png";